import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        path: "/",
        name: "home",
        component: () => import("../views/ScannerView.vue"),
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/ScannerView.vue"),
    },
    {
        path: "/:catchAll(.*)*",
        name: "catchAll",
        component: () => import("../views/NotFoundView.vue"),
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
